module.exports = __webpack_public_path__ + "img/resources-768.3f3f8642.jpg";